import { CHAIN_USDC_ADDRESSES, CHAIN_WETH_ADDRESSES } from "../../tokens.js";
import { TRANSFER_TOPIC, VITALIK } from "../../integration.js";
import { CORE_PINNED_BLOCK_HASHES, CORE_PINNED_BLOCK_HEIGHTS, CORE_PINNED_TRANSACTION_HASHES } from "../pinned.js";
import { AAVE_V3_COLLECTOR, ERC20_BALANCE_OF_REFERENCE_CALLDATA, OPTIMISM_USDC_ALLOWANCE_OWNER, OPTIMISM_USDC_ALLOWANCE_SPENDER, SWAP_QUOTE_AMOUNT, } from "../fixture-inputs.js";
export const OPTIMISM_TEST_CONFIG = {
    balance: {
        address: VITALIK,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.optimism,
    },
    tokenBalance: {
        address: VITALIK,
        token: CHAIN_USDC_ADDRESSES.optimism,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.optimism,
    },
    blockQuery: {
        block: CORE_PINNED_BLOCK_HEIGHTS.optimism,
        fixture: "getBlockByNumberOptimism",
    },
    balanceQuery: {
        address: VITALIK,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.optimism,
        fixture: "getBalanceOptimism",
    },
    tokenBalanceQuery: {
        address: VITALIK,
        token: CHAIN_USDC_ADDRESSES.optimism,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.optimism,
        fixture: "getTokenBalanceOptimism",
    },
    blockHashQuery: {
        hash: CORE_PINNED_BLOCK_HASHES.optimism,
        fixture: "getBlockByHashOptimism",
    },
    blockTransactionsQuery: {
        blockNumber: CORE_PINNED_BLOCK_HEIGHTS.optimism,
        fixture: "getBlockTransactionsOptimism",
    },
    transfersQuery: {
        address: VITALIK,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.optimism,
        fixture: "getTransfersOptimism",
    },
    simulateCallQuery: {
        to: CHAIN_USDC_ADDRESSES.optimism,
        data: ERC20_BALANCE_OF_REFERENCE_CALLDATA,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.optimism,
        fixture: "simulateCallOptimism",
    },
    traceTransactionQuery: {
        hash: CORE_PINNED_TRANSACTION_HASHES.optimism,
        fixture: "traceTransactionOptimism",
    },
    tokenMetadataQuery: {
        address: CHAIN_USDC_ADDRESSES.optimism,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.optimism,
        fixture: "getTokenMetadataOptimism",
    },
    tokenAllowanceQuery: {
        token: CHAIN_USDC_ADDRESSES.optimism,
        owner: OPTIMISM_USDC_ALLOWANCE_OWNER,
        spender: OPTIMISM_USDC_ALLOWANCE_SPENDER,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.optimism,
        fixture: "getTokenAllowanceOptimism",
    },
    portfolioQuery: {
        address: VITALIK,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.optimism,
    },
    receiptQuery: {
        hash: CORE_PINNED_TRANSACTION_HASHES.optimism,
        fixture: "getReceiptOptimism",
    },
    transactionByHashQuery: {
        hash: CORE_PINNED_TRANSACTION_HASHES.optimism,
        fixture: "getTransactionByHashOptimism",
    },
    estimateGasQuery: {
        to: VITALIK,
        fixture: "estimateGasOptimism",
    },
    codeQuery: {
        address: CHAIN_USDC_ADDRESSES.optimism,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.optimism,
        fixture: "getCodeOptimism",
    },
    logsQuery: {
        address: CHAIN_USDC_ADDRESSES.optimism,
        topic0: TRANSFER_TOPIC,
        fromBlock: String(CORE_PINNED_BLOCK_HEIGHTS.optimism),
        toBlock: String(CORE_PINNED_BLOCK_HEIGHTS.optimism),
        fixture: "getLogsOptimism",
    },
    aaveV3Query: { address: AAVE_V3_COLLECTOR.optimism, blockHeight: CORE_PINNED_BLOCK_HEIGHTS.optimism, fixture: "getAaveV3UserPositionsOptimism" },
    lidoQuery: { address: VITALIK, blockHeight: CORE_PINNED_BLOCK_HEIGHTS.optimism, fixture: "getLidoUserPositionsOptimism" },
    morphoQuery: { address: VITALIK, blockHeight: CORE_PINNED_BLOCK_HEIGHTS.optimism, fixture: "getMorphoUserPositionsOptimism" },
    curveLlamaLendQuery: { address: VITALIK, blockHeight: CORE_PINNED_BLOCK_HEIGHTS.optimism, fixture: "getCurveLlamaLendOptimism" },
    approvalsQuery: { address: VITALIK, blockHeight: CORE_PINNED_BLOCK_HEIGHTS.optimism, fixture: "getApprovalsOptimism" },
    pendleV2InfoQuery: { fixture: "getPendleV2InfoOptimism" },
    curvePoolsQuery: { blockHeight: CORE_PINNED_BLOCK_HEIGHTS.optimism, fixture: "getCurvePoolsOptimism" },
    curveLlamaLendMarketsQuery: { blockHeight: CORE_PINNED_BLOCK_HEIGHTS.optimism, fixture: "getCurveLlamaLendMarketsOptimism" },
    uniswapV3QuoteQuery: { tokenIn: CHAIN_WETH_ADDRESSES.optimism, tokenOut: CHAIN_USDC_ADDRESSES.optimism, amount: SWAP_QUOTE_AMOUNT, blockHeight: CORE_PINNED_BLOCK_HEIGHTS.optimism, fixture: "getUniswapV3QuoteOptimism" },
};
